// extracted by mini-css-extract-plugin
export default {"modalOverlay":"vA-z","modalContent":"wA-z","header":"xA-z","close":"yA-z"};